import styled from 'styled-components';

export const MobileWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border:0;
`;

export const LoadingSpin = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MobileContainer = styled.div`
  max-width: 600px;
  width: 100%;
  margin: auto;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  // border: 1px solid #f1f1f1;
  border:0;
  min-height: 100vh;
`;

export const MobileImgBox = styled.div`
  width: 100%;
  background-color: white;
  border:0;

  & img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const ContantDetailColor = styled.div`
  background-color: #333;
`;

export const MobileTitle = styled.div`
  font-weight: 600;
  white-space: pre-wrap;
  color: #39392a;
`;

export const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  position: relative;
  top: -35px;

  width: 90%;
  max-width: 400px;
  line-height: 20px;
  padding: 20px;
  background-color: white;
  white-space: pre-wrap;
  border-bottom: 3px solid #f9f9f9;
  border-top: 3px solid #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 20px;
  margin: 10px;
  gap: 10px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const MobileContentTitle = styled.div`
  font-weight: 600;
  white-space: pre-wrap;
  color: #39392a;
`;

export const MobileContentDetail = styled.div`
  // color: #8f8e8f;
  bold: 400;
  // make font more readable and bigger and change color make it bolder
  font-size: 16px;
  // color: #3e3e3e;
  // 눈에 띄고 더 밝은 색상으로 변경
  color: #03C75A;
  font-weight: bold;
`;

export const MobilePointButton = styled.button`
  width: 100%;
  max-width: 400px;
  color: white;
  border: none;
  font-size: 17px;
  cursor: pointer;
  outline: none;
  border-radius: 5px;
  height: 40px;
  height: 100%;
  padding: 10px;
  background-color: #0043cc;
  border-radius: 5px;

  &:hover {
    background-color: #047af2;
  }

  &:disabled {
    background-color: #ccc;
    color: #fff;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const MobileBtnLink = styled.a`
  width: 90%;
`;

export const ContactUsLink = styled.a`
  width: 90%;
`;

export const AdditionaTextBox = styled.div`
  width: 90%;
  position: relative;
  top: -20px;

  line-height: 25px;
  color: #3e3e3e;
  font-weight: 400;
  font-size: 14px;
  background-color: #f6f6f6;
`;

export const AdditionaTextItem = styled.div`
  display: flex;
  color: #8f8e8f;
  font-size: 14px;
  background-color: #f6f6f6;
  width: 100%;
`;

export const ContactUsBtn = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  color: #333;
  border: none;
  font-size: 15px;
  outline: none;
  margin: 10px 0;
  cursor: pointer;

  p {
    color: #0043CC;
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const Star = styled.div`
  color: #0043CC;
  margin-right: 10px;
  font-size: 18px;
`;

export const GreenButton = styled.button`
  background-color: #57D958;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  font-size: 15px;
  color: white;
  width: 100%;
  border-radius: 5px;

  &:hover {
    background-color: darkgreen;
  }

  &:focus {
    background-color: darkgreen;
  }
`;